import * as React from "react";

import Help from "@material-ui/icons/HelpTwoTone";
import { Trans, WithTranslation, withTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import CardList from "~/components/CustomerSupport/CardList";
import Topic from "~/components/CustomerSupport/Topic";
import NotificationsContainer from "~/containers/Notifications/NotificationsContainer";
import RMAFormContainer from "~/containers/RMAForm/RMAFormContainer";
import { shopConfig } from "~/helpers/shopConfig";
import { StyledCard as Card } from "~/layouts/StyledCard";
import SupportDashboardLayout from "~/layouts/SupportDashboardLayout";
import styled from "~/styled";

const Typography = styled.p`
  font-size: 14px;

  @media (max-width: 375px) {
    font-size: 12px;
  }
`;

class RMAFormIndex extends React.Component<
  WithTranslation & RouteComponentProps<{}>
> {
  public render() {
    const {
      t,
      location: { search }
    } = this.props;

    const query = new URLSearchParams(search);
    const orderNumber = query.get("orderNumber") || "";
    const reason = query.get("reason") || "";
    const notify = query.get("notify");

    const { brandName, organization } = shopConfig;

    const canselationFormURL = `https://files.${brandName.toLowerCase()}.com/documents/legal/${organization}/cancellation_form.pdf`;

    return (
      <SupportDashboardLayout>
        <CardList>
          <Card>
            <Topic
              title={t("header.title")}
              description={t("header.description")}
              icon={Help}
            />
          </Card>

          <NotificationsContainer />

          {notify !== null &&
            notify === "rma_redirect" &&
            t("notifications.redirection")}
          <RMAFormContainer orderNumber={orderNumber} reason={reason} />

          <Trans i18nKey="rmaForm:cancellationFormPDF.message">
            <Typography>
              You also have the right to return your return directly to us
              without the intervention of customer service. Download form&nbsp;
              <a href={canselationFormURL} target="_blank">
                here
              </a>
            </Typography>
          </Trans>
        </CardList>
      </SupportDashboardLayout>
    );
  }
}

export default withTranslation("rmaForm")(RMAFormIndex);



// WEBPACK FOOTER //
// ./src/pages/RMA/RMAFormIndex.tsx